import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { PageTransition } from "@/components/PageTransition";
import FAQ from "@/pages/FAQ";

export const Route = createFileRoute("/faq")({
  component: FAQRoute,
});

function FAQRoute() {
  return (
    <PageTransition>
      <Suspense fallback={<div className="min-h-screen bg-background" />}>
        <FAQ />
      </Suspense>
    </PageTransition>
  );
}
